import React, { useRef } from 'react';
import Slider from 'react-slick';
import CasesCard from './CasesCard';
import 'slick-carousel/slick/slick.css';
import useScrollObserver from '../../../../hooks/useScrollObserver';

const CasesSlider = () => {
  const slider = useRef();
  const observerRef = useRef();
  const handleScrollIntoView = () => {
    observerRef.current.classList.add('animate');
  };
  useScrollObserver(observerRef, handleScrollIntoView);

  const settings = {
    initialSlide: 0, // Ensure slider starts from the first slide
    infinite: true,
    speed: 300,
    swipe: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: false,
    autoplay: false,
    responsive: [
      {
        breakpoint: 1124,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },

      {
        breakpoint: 767,
        settings: {
          variableWidth: true,
          slidesToShow: 1,
          swipe: true,
          arrows: false,
          dots: true,
          dotsClass: 'custom-dots',
          centerPadding: '15px',
        },
      },
    ],
  };

  return (
    <>
      <style>
        {`
          .slick-list {
            overflow: hidden; 
          }
         .cases-slider .slick-track {
            display: flex;
            align-items: center;
          }
          .slick-slide {
            outline: none;
          }
          .slick-slide div {
            outline: none;
          }
          .custom-dots {
            display: flex !important;
            justify-content: center;
          }
          .custom-dots li {
            position: relative;
            margin: 0 3px;
            margin-top: 20px;
            width: 50px;
            height: 2px;
            background-color: #C4C4C4;
            overflow: hidden;
          }
         .cases-slider .custom-dots li.slick-active {
            background-color: #D9A8E5;
          }
          .custom-dots li button {
            position: absolute;
            width: 100%;
            height: 100%;
            top: 0;
            left: 0;
            opacity: 0;
          }
        `}
      </style>
      <div ref={observerRef} className="w-full ">
        <Slider {...settings} className="cases-slider w-full ">
          <div className="block px-[13px] pb-[48px] fade-in-from-bottom ease-out">
            <CasesCard
              cardClass="py-[32px] px-[16px] md:px-[32px]"
              logoUrl="/images/seo/logos/Arara.png"
              logoClass="max-h-[56px]"
              imageUrl="/images/seo/airplane.png"
              imageClass="-bottom-[43px] md:top-[150px] fade-in-from-bottom animation-delay-400 ease-in"
              increaseNum="+180%"
              increaseText="increase in organic traffic"
              avgNum="80"
              avgText="avg monthly organic leads"
              monthNum="6"
              monthText="months"
            />
          </div>
          <div className="block px-[13px] pb-[48px] fade-in-from-bottom ease-out animation-delay-200">
            <CasesCard
              cardClass="py-[31px] px-[26px]"
              logoUrl="/images/seo/logos/Amira.png"
              logoClass="max-h-[90px]"
              imageUrl="/images/seo/towel.png"
              imageClass="-bottom-[43px] md:top-[127px] fade-in-from-bottom  animation-delay-600 ease-in"
              increaseNum="+103,6% "
              increaseText="increase in organic traffic"
              avgNum="10450"
              avgText="organic sessions"
              monthNum="5"
              monthText="months"
            />
          </div>
          <div className="block px-[13px] pb-[48px] fade-in-from-bottom ease-out animation-delay-400">
            <CasesCard
              cardClass="py-[43px] px-[37px]"
              logoUrl="/images/seo/logos/GreenRock.png"
              logoClass="max-h-[36px]"
              imageUrl="/images/seo/computer.png"
              imageClass="-bottom-[43px] md:top-[137px] fade-in-from-bottom animation-delay-800 ease-in"
              increaseNum="+75%"
              increaseText="increase in organic traffic"
              avgNum="1200"
              avgText="organic sessions"
              monthNum="2"
              monthText="months"
            />
          </div>
        </Slider>
      </div>
    </>
  );
};

export default CasesSlider;
